// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"298":"5192a54c","453":"5a1ed4d2"}[chunkId] + ".chunk.js";
};